import { CommonRecipe, CommonRecipeTag } from "@/types/commonRecipe";

/** お気に入り関連 */
export interface RootState {
  version: string;
}

export interface FavoritesState {
  addRecipeResult: FavoriteOperationResult | null;
  deleteRecipeResult: FavoriteOperationResult | null;
  recentMylist: FavoriteRecipeClips | null;
  mylist: FavoriteRecipeClips | null;
  folderList: FavoriteFolders | null;
  folderRecipeList: FavoriteFolderClips | null;
  registFolderResult: FavoriteFolderOperationResult | null;
  renameFolderResult: FavoriteFolderOperationResult | null;
  deleteFolderResult: FavoriteFolderOperationResult | null;
  addFolderRecipeResult: FavoriteOperationResult | null;
  deleteFolderRecipeResult: FavoriteOperationResult | null;
  folderMoveResult: FavoriteOperationResult | null;
  folderName: string | null;
  sendedHistory: FavoriteSendedHistoryRecipes | null;
  viewedHistory: FavoriteHistoryRecipes | null;
  selectedTab: number;
}

/** お気に入り関連のComponent間インターフェース定義 */

/*********************
 * APIのレスポンス定義
 *********************/
/**
 * API お気に入りフォルダ内のレシピ情報 付属品情報
 */
export class FavoriteRecipeAttachment {
  id: string;
  description: string;

  constructor() {
    this.id = "";
    this.description = "";
  }
}
/**
 * API お気に入りフォルダ内のレシピ情報 作成者情報
 */
export class FavoriteRecipeMenuAuthor {
  name: string;
  forDisplay: string;

  constructor() {
    this.name = "";
    this.forDisplay = "";
  }
}
/**
 * API お気に入りフォルダ内のレシピ情報の栄養情報
 */
export class FavoriteRecipeNutrition {
  note: string;
  calories: number;
  salt: number;
  carbohydrate: number;
  lipid: number;
  protein: number;

  constructor() {
    this.note = "";
    this.calories = 0;
    this.salt = 0;
    this.carbohydrate = 0;
    this.lipid = 0;
    this.protein = 0;
  }
}
/**
 * API お気に入りフォルダ内のレシピ情報のタグ情報
 */
export interface FavoriteRecipeTag {
  id: number;
  name: string;
}

/**
 * API お気に入りフォルダ一覧の要素定義
 */
interface FavoriteFolder {
  favoriteFolderId: number;
  name: string;
  imageUrl: string;
  clipCount: number;
}

/**
 * API お気に入りフォルダ一覧取得のレスポンス定義
 */
export class FavoriteFolders {
  folders: Array<FavoriteFolder>;
  folderCount: number;

  constructor() {
    this.folders = [];
    this.folderCount = 0;
  }
}

/**
 * API レシピンのタイトル・ラベル
 */
export class FavoriteRecipeTitleLabel {
  description: string;
  fgColor: string;
  bgColor: string;
  constructor() {
    this.description = "";
    this.fgColor = "";
    this.bgColor = "";
  }
}

/**
 * API レシピの画像
 */
export class FavoriteRecipeImage {
  original: string;
  main: string;
  thumb: string;
  constructor() {
    this.original = "";
    this.main = "";
    this.thumb = "";
  }
}

/**
 * API レシピのリアクション
 */
export class FavoriteRecipeReaction {
  done: boolean;
  count: number;
  constructor() {
    this.done = false;
    this.count = 0;
  }
}

/**
 * API レシピのリアクション
 */
export class FavoriteRecipeReactions {
  like: FavoriteRecipeReaction;
  favorite: FavoriteRecipeReaction;
  myComment: FavoriteRecipeReaction;
  constructor() {
    this.like = new FavoriteRecipeReaction();
    this.favorite = new FavoriteRecipeReaction();
    this.myComment = new FavoriteRecipeReaction();
  }
}

/**
 * API お気に入りフォルダ登録／変更のレスポンス定義
 */
export class FavoriteFolderOperationResult {
  favoriteFolderId: number;
  name: string;
  created: string;

  constructor() {
    this.favoriteFolderId = 0;
    this.name = "";
    this.created = "";
  }
}

/**
 * API お気に入りフォルダ内のレシピ情報 レシピ定義
 */
export class FavoriteRecipeClip {
  recipeId: number;
  caption: string;
  imageUrl: string;
  moduleType: string;
  nutrition: FavoriteRecipeNutrition;
  device: string;
  applianceCategoryId: number;
  productId: string;
  attachments: Array<FavoriteRecipeAttachment> | null;
  isFormal: boolean;
  author: FavoriteRecipeMenuAuthor;
  numComment: number;
  numGood: number;
  goodStatus: boolean;
  favoriteStatus: boolean;
  commentStatus: boolean;
  dishType: string;
  groupId: number;
  dlMenuId: string;
  type: string;
  tags: Array<FavoriteRecipeTag>;
  releaseDate: string;
  defaultDlMenuId: number;

  constructor() {
    this.recipeId = 0;
    this.caption = "";
    this.imageUrl = "";
    this.moduleType = "";
    this.nutrition = new FavoriteRecipeNutrition();
    this.device = "";
    this.applianceCategoryId = 0;
    this.productId = "";
    this.attachments = null;
    this.isFormal = false;
    this.author = new FavoriteRecipeMenuAuthor();
    this.numComment = 0;
    this.numGood = 0;
    this.goodStatus = false;
    this.favoriteStatus = false;
    this.commentStatus = false;
    this.dishType = "";
    this.groupId = 0;
    this.dlMenuId = "";
    this.type = "";
    this.tags = [];
    this.releaseDate = "";
    this.defaultDlMenuId = 0;
  }
}

/**
 * お気に入りのレシピ取得結果
 */
export class FavoriteRecipeClips {
  clips: Array<FavoriteRecipeClip>;
  totalCount: number;
  start: number;
  lastUpdate: string;

  constructor() {
    this.clips = [];
    this.totalCount = 0;
    this.start = 0;
    this.lastUpdate = "";
  }
}

/**
 * API お気に入りフォルダ内のレシピ情報取得のレスポンス
 */
export class FavoriteFolderClips {
  favoriteFolderId: number;
  name: string;
  imageUrl: string;
  start: number;
  totalCount: number;
  clips: Array<FavoriteRecipeClip>;
  created: string;
  lastUpdate: string;

  constructor() {
    this.favoriteFolderId = 0;
    this.name = "";
    this.imageUrl = "";
    this.start = 0;
    this.totalCount = 0;
    this.clips = [];
    this.created = "";
    this.lastUpdate = "";
  }
}

/**
 * API お気に入りフォルダ更新レスポンス
 */
export class FavoriteFolderUpdate {
  favoriteFolderId: number;
  name: string;
  created: string;

  constructor() {
    this.favoriteFolderId = 0;
    this.name = "";
    this.created = "";
  }
}

/**
 * API お気に入りフォルダ・レシピ追加/削除の要素
 */
interface FavoriteFolderOperationRecipe {
  recipeId: number;
}

/**
 * API お気に入りフォルダ・レシピ追加/削除のレスポンス
 */
export class FavoriteFolderOperationRecipeList {
  recipes: Array<FavoriteFolderOperationRecipe>;

  constructor() {
    this.recipes = [];
  }
}

/**
 * API お気に入りフォルダ・レシピ追加定義
 */
export class FavoriteAddFolderRecipe {
  recipeId: number;
  groupId: number;

  constructor(recipeId: number, groupId: number) {
    this.recipeId = recipeId;
    this.groupId = groupId;
  }
}

/**
 * API お気に入りフォルダ・レシピ削除定義
 */
export class FavoriteDeleteFolderRecipe {
  recipeId: number;

  constructor(recipeId: number) {
    this.recipeId = recipeId;
  }
}

/**
 * API お気に入りフォルダ・レシピ追加/削除のレスポンス
 */
export class FavoriteOperationResult {
  status: boolean;

  constructor() {
    this.status = true;
  }
}

/**
 * フォルダ表示定義
 */
export class FolderInfo {
  id: number;
  name: string;
  image: string;
  numberOfItems: number;
  constructor() {
    this.id = 0;
    this.name = "";
    this.image = "";
    this.numberOfItems = 0;
  }
}

/**
 * 履歴取得結果
 */
export class FavoriteHistoryRecipe {
  recipeId: number;
  groupId: number;
  title: string;
  subTitle: string;
  applianceCategory: string;
  applianceCategoryId: number;
  productId: string;
  attachments: Array<FavoriteRecipeAttachment> | null;
  dishType: string;
  nutrition: FavoriteRecipeNutrition;
  author: FavoriteRecipeMenuAuthor;
  type: string;
  titleLabel: FavoriteRecipeTitleLabel;
  images: Array<FavoriteRecipeImage>;
  tags: Array<FavoriteRecipeTag>;
  defaultDlMenuId: number;
  reactions: FavoriteRecipeReactions;
  isNew: boolean;
  releaseDate: string;

  constructor() {
    this.recipeId = 0;
    this.groupId = 0;
    this.title = "";
    this.subTitle = "";
    this.applianceCategory = "";
    this.applianceCategoryId = 0;
    this.productId = "";
    this.attachments = [];
    this.dishType = "";
    this.nutrition = new FavoriteRecipeNutrition();
    this.author = new FavoriteRecipeMenuAuthor();
    this.type = "";
    this.titleLabel = new FavoriteRecipeTitleLabel();
    this.images = [];
    this.tags = [];
    this.defaultDlMenuId = 0;
    this.reactions = new FavoriteRecipeReactions();
    this.isNew = false;
    this.releaseDate = "";
  }
}

/**
 * 履歴取得結果
 */
export class FavoriteHistoryRecipes {
  recipes: Array<FavoriteHistoryRecipe>;
  totalCount: number;
  start: number;

  constructor() {
    this.recipes = [];
    this.totalCount = 0;
    this.start = 0;
  }
}

/**
 * 送信履歴取得結果
 */
export class FavoriteSendedHistoryRecipe {
  recipeId: number;
  groupId: number;
  recipeName: string;
  imageUrl: string;
  applianceCategory: string;
  applianceCategoryId: number;
  lastDownloaded: string;

  constructor() {
    this.recipeId = 0;
    this.groupId = 0;
    this.recipeName = "";
    this.imageUrl = "";
    this.applianceCategory = "";
    this.applianceCategoryId = 0;
    this.lastDownloaded = "";
  }
}

/**
 * 履歴取得結果
 */
export class FavoriteSendedHistoryRecipes {
  recipes: Array<FavoriteSendedHistoryRecipe>;
  totalCount: number;
  start: number;

  constructor() {
    this.recipes = [];
    this.totalCount = 0;
    this.start = 0;
  }
}

/** スクロールイベントのIF */
export interface HTMLElementEvent<T extends HTMLElement> extends Event {
  target: T;
}

export type HTMLDivElementEvent = HTMLElementEvent<HTMLDivElement>;

